// extracted by mini-css-extract-plugin
export default {"wrapper":"pannel_wrapper__FaF+g"};